import React from 'react';
import { useAuth } from '@store/authStore';
import AttendanceHistory from '@pages/employee/AttendanceHistory';
import AdminAttendanceHistory from '@pages/admin/AdminAttendanceHistory';
import PMAttendanceHistory from '@pages/programManager/PMAttendanceHistory';
import HRAttendanceHistory from '@pages/hr/HRAttendanceHistory';

const AttendanceHistoryRouter: React.FC = () => {
  const { user } = useAuth();

  console.log('AttendanceHistoryRouter: User role:', user?.role);

  // Render attendance history based on user role
  if (user?.role === 'Admin') {
    console.log('AttendanceHistoryRouter: Rendering Admin Attendance History');
    return <AdminAttendanceHistory />;
  }

  if (user?.role === 'HR') {
    console.log('AttendanceHistoryRouter: Rendering HR Attendance History');
    return <HRAttendanceHistory />;
  }

  if (user?.role === 'Employee') {
    console.log('AttendanceHistoryRouter: Rendering Employee Attendance History');
    return <AttendanceHistory />;
  }

  if (user?.role === 'Program Manager') {
    console.log('AttendanceHistoryRouter: Rendering Program Manager Attendance History');
    return <PMAttendanceHistory />;
  }

  // Default to Employee view for unknown roles
  console.log('AttendanceHistoryRouter: Rendering default Employee Attendance History');
  return <AttendanceHistory />;
};

export default AttendanceHistoryRouter;
